import { makeVar } from "@apollo/client";

export const globalIsDirtyVar = makeVar(false);